import { IComponentOptions } from "angular";
import { MachineTypeIdInfoMachineEditComponentController } from "./controller";

export const vsComponentName = "machineTypeIdInfoMachinesEditComponent";

export const machineTypeIdInfoMachineEditComponentOptions: IComponentOptions = {
  controller: MachineTypeIdInfoMachineEditComponentController,
  controllerAs: "typeIdMachineEditController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    gridConfiguration: "<",
    typeId: "<",
    initialSelectedIds: "<",
  },
};
